import React from "react";
import { trackLead } from "../../lib/track";

const TELEGRAM_URL = "https://t.me/+cr1LhxIMB-5jODJl";

const Footer = () => {
  return (
    <footer className="relative border-t border-white/[0.06]" data-testid="footer">
      <div className="mx-auto max-w-[1200px] px-6 md:px-10 py-12 md:py-16">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-10">
          <div>
            <div className="flex items-center gap-3">
              <div
                className="h-9 w-9 rounded-full ring-1 ring-white/10"
                style={{
                  backgroundImage: `url(/assets/logo.png)`,
                  backgroundSize: "180%",
                  backgroundPosition: "center 22%",
                  backgroundRepeat: "no-repeat",
                }}
                aria-label="BIGBULL"
              />
              <span className="font-display text-[16px] tracking-[0.24em] text-white">BIGBULL</span>
            </div>
            <p className="mt-5 max-w-[360px] text-[13px] text-white/45 leading-relaxed">
              AI-powered OTC binary trading system. Built for Quotex precision,
              structure, and long-term compounding.
            </p>
          </div>

          <div className="flex flex-col md:items-end gap-4">
            <a
              href={TELEGRAM_URL}
              target="_blank"
              rel="noreferrer"
              onClick={() => trackLead("footer_telegram")}
              className="font-display text-[20px] md:text-[24px] tracking-tight text-white hover:text-[#cfe6ff] transition-colors"
              data-testid="footer-telegram"
            >
              @bigbullamitfx
            </a>
            <span className="text-[10.5px] tracking-[0.3em] uppercase text-white/40">
              Telegram · Official
            </span>
          </div>
        </div>

        <div className="h-divider mt-12" />

        <div className="mt-7 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <p className="text-[11.5px] text-white/35 max-w-[640px]">
            Trading involves risk. Trade responsibly. Past performance does not
            guarantee future results.
          </p>
          <p className="text-[10.5px] tracking-[0.3em] uppercase text-white/30">
            © {new Date().getFullYear()} BIGBULL AI BOT
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
